import { render, staticRenderFns } from "./ClinicList.vue?vue&type=template&id=50cd9591&"
import script from "./ClinicList.vue?vue&type=script&lang=js&"
export * from "./ClinicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports